export { default } from "./Checkbox";
export type { CheckboxConfig } from "./Checkbox";
